import { api } from "@/api/client";
import type { PersonRequestMove, PersonRequestOut } from "@/api/types";

/**
 * Spec 033: addressed requests. The asked person answers right in «Решить» (text or one of
 * the answers); the author accepts the answer, asks again or cancels. One retry key per move.
 */
export const PersonRequests = {
  move: (id: string, body: PersonRequestMove, key: string) =>
    api<PersonRequestOut>(`/api/v1/requests/${id}`, { method: "POST", body, idempotent: key }),
};
